import { ToastController,Platform  } from '@ionic/angular';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { UserService } from 'src/app/services/user/user.service';
import { SharedNewService } from 'src/app/services/shared-new/shared-new.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { LabelService } from 'src/app/services/label/label.service';
import { ProductService } from 'src/app/services/product/product.service';
import { encodeURL } from 'src/app/services/parseURL';


@Component({
  selector: 'app-product-thumb-three',
  templateUrl: './product-thumb-three.component.html',
  styleUrls: ['./product-thumb-three.component.scss'],
})
export class ProductThumbThreeComponent implements OnInit {

  @Input() product: any;
  @Input() gridType: string;
  @Input() subscriptionFeature: boolean;
  @Input() showPrices: boolean;
  @Input() role: string;
  @Input() index: number;
  @Input() style: any;

  @Output() openPriceModalEvent = new EventEmitter<number>();
  @Output() addProductToCartEvent = new EventEmitter<number>();
  @Output() decrementQuantityEvent = new EventEmitter<number>();
  @Output() incrementQuantityEvent = new EventEmitter<number>();
  @Output() goToProductEvent = new EventEmitter<number>();
  @Output() heartClickedEvent = new EventEmitter<number>();
  @Output() deleteWishlistPdtEvent = new EventEmitter<number>();
  @Output() priceListFirstToCartEvent = new EventEmitter<number>();

  isPriceReq: boolean;
  minOrderAmount = 0;
  currencyCode: string = 'INR';
  userId = '';
  RFQFeature = false;
  useThumb: boolean;
  SHARED_LABELS: any;

  constructor(
      private userService: UserService,
      private toastController: ToastController,
      private configService: ConfigService,
      private cartService: CartService,
      private platform:Platform,
      private sharedNewService: SharedNewService,
      private sharedService: SharedService,
      private labelService: LabelService,
      private productService: ProductService
  ) {
     
   }

  async ngOnInit() {

      this.platform.ready().then(() => {

          let deviceWidth = this.platform.width();
          if (deviceWidth > 786) {
              this.useThumb = false;
              
          } else {
              this.useThumb = false;
          }
        });
      this.currencyCode = this.configService.environment.currencyCode;
      this.RFQFeature = this.configService.environment.RFQFeature;
      this.isPriceReq = this.configService.environment.priceReqFeature;
      this.userId = this.userService.getUserId();
      this.SHARED_LABELS = this.labelService.labels['SHARED'];
  }

  isProductSubAvailable(product) {
      return this.subscriptionFeature && product.hasOwnProperty('subscription') && product.subscription.isAllowed ? true : false;
  }

  checkPdtStock(pdt) {
      let isOutOfStock = false;
      if (!pdt.isPriceList) {
          if (pdt.productQty === '0' && pdt.stopWhenNoQty) {
              isOutOfStock = true;
          }
      } else {
          if (pdt.stopWhenNoQty) {
              for (const pl of pdt.priceList) {
                  if (pl.totalQuantity !== '0') {
                      isOutOfStock = false;
                      break;
                  } else {
                      isOutOfStock = true;
                  }
              }
          }
      }
      return isOutOfStock;
  }

  getDiscountPercent(discountedPrice, prodPrice) {
      if (prodPrice > discountedPrice) {
          const discount = Math.round(((prodPrice - discountedPrice) / prodPrice) * 100);
          return discount;
      } else {
          return 0;
      }
  }

  removeHtml(desc) {
      const tagsRemoved = desc.replace(/(<([^>]+)>)/ig, '');
      const plainTxt = document.createElement('textarea');
      plainTxt.innerHTML = tagsRemoved;
      return plainTxt.value;
  }

  maxQtyReached() {
      this.presentToast('Sorry, you can not add more of this item', 'warning');
  }

  async presentToast(msg: string, clr) {
      const toast = await this.toastController.create({
          message: msg,
          duration: 2000,
          position: 'top',
          color: clr

      });
      toast.present();
  }

  isProductInCart(product) {
      return this.cartService.isProductInCart(product)
  }

  getMinPrice(pl: any) {
      const dPList = [];
      pl.forEach(e => {
          dPList.push(e.discountedPrice);
      });
      return Math.min(...dPList);
  }

  getMaxPrice(pl: any) {
      const dPList = [];
      pl.forEach(e => {
          dPList.push(e.discountedPrice);
      });
      return Math.max(...dPList);
  }

  getPriceListDiscountPercent(priceList) {
      if (priceList && priceList.length) {
          const plDiscountList = [];
          priceList.forEach(pl => {
              const plDiscount = ((pl.price - pl.discountedPrice) / pl.price) * 100;
              plDiscountList.push(plDiscount);
          });
          return parseInt((Math.max(...plDiscountList)).toFixed(2));
      } else {
          return 0;
      }
  }

  async openPriceModal() {
    this.openPriceModalEvent.emit(this.index);
  }

  async addProductToCart() {
    this.addProductToCartEvent.emit(this.index);
  }

  async decrementQuantity() {
    this.decrementQuantityEvent.emit(this.index);
  }
  async incrementQuantity() {
    this.incrementQuantityEvent.emit(this.index);
  }

  goToProduct() {
    this.goToProductEvent.emit(this.index);
  }

  async heartClicked() {
    this.heartClickedEvent.emit(this.index);
  }

  async deleteWishlistPdt() {
    this.deleteWishlistPdtEvent.emit(this.index);
  }

  priceListFirstToCart() {
      if (this.product.data.priceList[0].totalQuantity === '0') {
          this.openPriceModalEvent.emit(this.index);
      } else {
          this.priceListFirstToCartEvent.emit(this.index);
      }
  }

  showQtyLeftMsg(product: any) {
      return this.sharedNewService.showQtyLeftMsg(product);
  }

  async notifyMe(product: any) {
      const res = await this.sharedService.checkLoginStatus(this.SHARED_LABELS['must_be_user_msg']);
      if(res) {
          const data = {
              id: product.id,
              parentId: product.data.hasOwnProperty('ptype') && product.data.ptype === 'child' ? product.data.parentId : ''
          }
          this.productService.notifyProduct(data);
          this.sharedService.presentAlert(this.SHARED_LABELS['notify_toast_msg']);
      }
  }

  getProductRouteUrl(productName: string, productID: string) {
      return `product-details/${this.urlPdtName(productName)}/${productID}`;
  }

  urlPdtName(pname: string) {
      return encodeURL(pname);
  }

  getPriceListWeight(product) {
      if(product.variantType !== 'pieces') {
          return product.priceList[0].weight;
      } else {
          if('name' in product.priceList[0]) {
              return product.priceList[0].name;
          } else {
              return product.priceList[0].weight;
          }
      }
  }

}
